import { IDuplicateCheckResult } from "Model/Omikron/IDuplicateCheckResult";
import { IState } from "Model/State/IState";
import { IProject } from "Model/Storage/IProject";

export function selectShowDuplicateCheckDialog(state: IState): boolean {
  return state.omikron.dc.showDialog;
}

export function selectDuplicateCheckResults(state: IState): IDuplicateCheckResult[][] {
  return state.omikron.dc.results;
}

export function selectDuplicateCheckCache(state: IState): IProject {
  return state.omikron.dc.cache;
}

export function selectDuplicateCheckActiveProjectId(state: IState): string {
  return state.omikron.dc.activeProjectId;
}

export function selectDuplicateCheckActiveProjectItemId(state: IState): string {
  return state.omikron.dc.activeProjectItemId;
}
